var exports = {
  "kL": "container__eGGsUV",
  "gn": "titleContainer__08OeZw",
  "iQ": "descriptionContainer__3M6LHr",
  "NC": "buttonsContainer__6nMgRi",
  "AK": "startTaskButton__I6SkdA",
};

module.exports = exports;
